import type { UploadState } from '@/constants/schema-constants'

export class ReportFileTaskStatusPutRequest {
  reportUploadId!: string
  uploadState!: UploadState;
  version!: number ;

  constructor(
    reportUploadId: string,
    uploadState: UploadState,
    version: number
  ) {
    this.reportUploadId = reportUploadId
    this.uploadState = uploadState
    this.version = version
  }
}

export class ReportFileTaskStatusPutResponse {
  version!: number
  constructor(version: number) {
    this.version = version
  }
}
